export default "__VITE_ASSET__DyD2cnJj__"